import i18n from "@/i18n";

export default {
  listHeaders() {
    return [
      { text: i18n.t('code'), value: 'id' },
      { text: i18n.t('vendorName'), value: 'tedarikciUnvani' },
      { text: i18n.t('taxNumber'), value: 'vergiNo' },
      { text: i18n.t('status'), value: 'statu' },
      { text: i18n.t('createDate'), value: 'olusturmaTarihi' },
    ];
  },
};
